import { useTranslation } from 'react-i18next';
import PromptTemplateSelector from '../PromptTemplateSelector';
import FieldSchemaEditor from '../FieldSchemaEditor';
import type { INodeConfig, IOutputField } from '@/types/docflow';

interface OutputDesignerConfigProps {
  config: INodeConfig;
  onChange: (config: INodeConfig) => void;
}

const OutputDesignerConfig: React.FC<OutputDesignerConfigProps> = ({ config, onChange }) => {
  const { t } = useTranslation('docflow');

  return (
    <div className="space-y-4">
      <h3 className="text-sm font-semibold text-gray-700 dark:text-gray-300">
        {t('node.outputDesigner')}
      </h3>

      {/* Template selector */}
      <PromptTemplateSelector
        value={config.template_name || ''}
        onSelect={(templateId: string, fields: IOutputField[]) => {
          onChange({
            ...config,
            template_name: templateId,
            fields: fields,
          });
        }}
      />

      {/* Field schema editor */}
      <FieldSchemaEditor
        fields={config.fields || []}
        onChange={(fields) => onChange({ ...config, fields })}
      />

      {/* Custom prompt override */}
      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
          {t('config.prompt')}
        </label>
        <textarea
          value={config.prompt || ''}
          onChange={(e) => onChange({ ...config, prompt: e.target.value })}
          placeholder={t('config.promptPlaceholder')}
          rows={3}
          className="w-full text-sm px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 dark:text-gray-200 resize-y"
        />
      </div>
    </div>
  );
};

export default OutputDesignerConfig;
